/**
 * Harry avatar — full-color illustrated mark for panel and floating launcher.
 */

export interface HarryIconProps {
  size?: number;
  pulse?: boolean;
  className?: string;
}

export function HarryIcon({ size = 28, pulse = false, className = '' }: HarryIconProps) {
  return (
    <span
      className={`relative inline-flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
      style={{ width: size, height: size }}
    >
      {pulse && (
        <span className="absolute inset-0 rounded-full ring-2 ring-sky-400/40 animate-agent-pulse" />
      )}
      <img
        src="/assets/harry-avatar.png"
        alt=""
        aria-hidden
        className="h-full w-full object-cover"
        draggable={false}
      />
    </span>
  );
}

/** @deprecated Use HarryIcon */
export const ConciergeIcon = HarryIcon;
